import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useJoinNetworkWithLink = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.auth.joinNetworkWithInvitationLink(input, fields), useMutationOptions);
};
//# sourceMappingURL=useJoinNetworkWithLink.js.map